const pageTitle = {
  'Google Merchant Center': 'Google Merchant Center - Shopping Ads Setting',
};

export default pageTitle;
